/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BezrealitkyInputs */

const cs_enum_bezrealitky = /** @type {(inputs: Enum_BezrealitkyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezrealitky`)
};

const en_enum_bezrealitky = /** @type {(inputs: Enum_BezrealitkyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezrealitky`)
};

/**
* | output |
* | --- |
* | "Bezrealitky" |
*
* @param {Enum_BezrealitkyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_bezrealitky = /** @type {((inputs?: Enum_BezrealitkyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BezrealitkyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_bezrealitky(inputs)
	return cs_enum_bezrealitky(inputs)
});